import { render, staticRenderFns } from "./SaveAlsoToModal.vue?vue&type=template&id=6b2de6ee&scoped=true&lang=pug"
import script from "./SaveAlsoToModal.vue?vue&type=script&lang=js"
export * from "./SaveAlsoToModal.vue?vue&type=script&lang=js"
import style0 from "./SaveAlsoToModal.vue?vue&type=style&index=0&id=6b2de6ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2de6ee",
  null
  
)

export default component.exports